import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

interface NimMemoriesParams {
  pageSize?: number;
  pageToken?: string;
  ownerIdFilter?: string;
  memoryTypeFilter?: string;
}

export const nimKeys = {
  all: ['nim'] as const,
  memories: (params: NimMemoriesParams) => [...nimKeys.all, 'memories', params] as const,
};

export function useNimMemories(params: NimMemoriesParams = {}) {
  return useQuery({
    queryKey: nimKeys.memories(params),
    queryFn: () => adminClient.listNimMemories(params),
  });
}
